import { NavigateFunction } from "react-router-dom";

export function SidebarClickHandler(control: boolean, link: string, navigate: NavigateFunction) {
    if (control) {
      window.open(link, '_blank', 'rel=noopener noreferrer');
    } else {
      navigate(link);
    }
  }